module.exports = ".app-content {\n  margin-left: 0px !important;\n  margin-bottom: 15px;\n  background: 0; }\n\n.content-wrapper {\n  width: 100%;\n  margin: auto; }\n\n@media only screen and (max-width: 480px) {\n  .navbarShow {\n    display: block !important; }\n  .sidebarShow {\n    display: block !important; } }\n\n@media only screen and (min-width: 700px) {\n  .navbarShow {\n    display: block !important; }\n  .sidebarShow {\n    display: none !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/2-columns-layout/2-columns-layout.component.scss
// module id = ./src/app/layouts/2-columns-layout/2-columns-layout.component.scss
// module chunks = main